/**
 * @file   src\components\CWInput.tsx
 * @brief  Input with label component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {React} from '../utils/thirdpartyComponents'
import { InputProperty } from '../interfaces/generalInterface';
import "../components/CWInputGroup.scss";

const CWInput = ({
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  label,
  isMandatory,
  errorMessage,
  value,
  id,
  name,
  type,
  accept,
  pattern,
  placeholder,
  disabled,
  maxLength,
  step,
  labelSuffix,
  inputIcons,
  showLabel,
  inputmode,
}: InputProperty) => {
 const displayLabel = (showLabel !== undefined) ? showLabel : true;
 
  return (
    <div className="form-group cw-inputgroup-wrap">
        {displayLabel ? <div className="cust-label-group">
        <label htmlFor="label">
          {label}
          {isMandatory && <span className="mandatory">*</span>}
          {labelSuffix ? <span className="label-suffix-class">{labelSuffix}</span> :''}
        </label>
        </div> : ''}
        <div className="input-group">
        <input
          className={errorMessage && errorMessage !== '' ? 'form-control error' : value !== '' ? 'form-control active' : 'form-control'}
          id={id}
          name={name}
          type={type}
          accept={accept}
          inputMode={inputmode}
          value={value}
          pattern={pattern}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={(event) => onChange && onChange(event)}
          onBlur={(event) => onBlur && onBlur(event)}
          step={step}
          onFocus={(event) => onFocus && onFocus(event)}
          onKeyDown={(event) => onKeyPress && onKeyPress(event)}
        />
        <span className="input-group-text">
        {inputIcons ? <img src={inputIcons} /> :''}
        </span>
        </div>
        
     
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
    </div>
  );
};

export default CWInput;
